var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"src":_vm.audio.src,"preload":""}},[_vm._v("对不起，您的浏览器不支持HTML5音频播放。")])}
var staticRenderFns = []

export { render, staticRenderFns }